import Table, { SORTER_STRING } from '../components/Table';
import { BrandBadge } from '../brands';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { useContext, useEffect } from 'react';
import { fetch } from '../store/shownDataSlice';
import * as common from './common';




const TODAY = new Date();

function FeedbacklessJobs({  }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const brandFilter = useSelector((state) => state.shownData.brandFilter);
    const _data = common.filterByBrand(useSelector((state) => state.shownData.feedbacklessJobs) || [], brandFilter);
    const data = _data.filter(row => !common.sameDay(TODAY, new Date(row["query_start"] * 1000)));
    const sortedData = [...data].sort((a, b) => {
        return a["query_start"] > b["query_start"] ? 1 : -1;
    });

    useEffect(() => {
        dispatch(fetch.feedbacklessJobs());
    }, []);



    return (
        <Table
            style={{ width: '100%' }}
            columnNames={[
                "Reisi kuupäev",
                "Firma",
                "Sihtkohad",
                "Reisijad",
                "Juht",
                "Maksumus",
                "Arve nr",
            ]}
            columnRenderers={[
                (row) => (<a onClick={() => navigate("/platform/job/" + row["query_id"])}>{common.displayDepart(row)}</a>),
                (row) => (<p>{row["query_brand"] === "triobuss" && <><BrandBadge brand={row["query_brand"]} />&nbsp;</>}{row["query_company"]}</p>),
                (row) => (<p style={{ maxWidth: 192, textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>{common.displayPrettyRoute(row)}</p>),
                (row) => (<p>{row["query_passengers"]}</p>),
                (row) => (<p>{common.displayDriver(row)}</p>),
                (row) => (<p>{common.displayPrice(row["query_response_price"])}</p>),
                (row) => (<p>{row["job_sequential_id"]}</p>),
            ]}
            columnSorters={[
                (a, b) => common.sortDepart(a, b),
                ({ query_company: a }, { query_company: b }) => SORTER_STRING(a, b),
                null,
                null,
                ({ driver_firstname: a }, { driver_firstname: b }) => SORTER_STRING(a, b),
                ({ job_sequential_id: a }, { job_sequential_id: b }) => (+a) - (+b),
            ]}
            data={sortedData}
        />
    );
}

export default FeedbacklessJobs;